namespace Solovis.Site.RequestNewInvestment {

  export interface EntityDefaultOptions {
    name?: string;
    localCurrencyId?: number;
  }

  export class AddEntityControl extends Solovis.UI.BaseControl {

    public _portalServices: Solovis.Portal.IPortalServices;

    public _entityEditModel;
    public _isDirty;
    public errorText;

    private _defaultLocalCurrencyId;
    public _formBuilder: Solovis.UI.InputControls.FormBuilder;

    private _formNames = {
      name: "name",
      localCurrency: "localCurrency",
      properties: "properties",
    };

    constructor(options: Solovis.UI.BaseControlOptions) {
      super(options);

      this._portalServices = new Solovis.Portal.SitePortalServices();

      this._isDirty = false;
    }

    public async doInitAsync(): Promise<void> {

      let response = await this._portalServices.rpc().invoke("~/DataManagement/EntityEditor/GetAddEntityDialogInitialState", null);

      this._defaultLocalCurrencyId = response.result.defaultLocalCurrencyId;
    }      


    public doRender() {
      const self = this;

      this.container.addClass("value-editor");

      if (this.errorText) {
        this.container.text(this.errorText);
        return;
      }

      const formDiv = $("<div>").appendTo(this.container);
      const formBuilder = new Solovis.UI.InputControls.FormBuilder({
        container: formDiv,
        labelColumnWidth: 150,
        width: 500,
        portalServices: this._portalServices
      });

      formBuilder.addEntry({
        name: this._formNames.name,
        label: "Name",

        editor: {
          type: "text",
          required: true,
        },
      });

      let localCurrencyIdToUse = this._defaultLocalCurrencyId;

      formBuilder.addEntry({
        name: this._formNames.localCurrency,
        label: "Local Currency",

        initialValue: localCurrencyIdToUse ? { id: localCurrencyIdToUse } : null,

        editor: {
          type: "parameter",
          parameterOptions: {
            parameterType: "currency"
          },
          required: true
        }
      });

      formBuilder.addEntry({
        name: this._formNames.properties,
        showValueOnFullRow: true,

        createEditor: (createEditorOptions) => {
          const propReportControl = new (Solovis as any).Reports.ReportControl({
            controlHost: createEditorOptions.container,

            hiddenParameters: ["resourceId"],

            report: {
              autoRun: true,
              hideConfigSection: true,
              root: {
                layout: "BlockWithHeader",

                header: {
                  headerText: "Properties"
                },

                content: {
                  elementName: "NewEntityProperties",

                  partControl: "Solovis.Reports.Parts.SubReportControl",

                  settings: {
                    usePersistedSettings: true,

                    reportOptions: function () {
                      const newEntityPropertyValuesReportCode = "73fd201e-e045-42e1-9053-4e1962f1448d";

                      const options = {
                        reportCode: newEntityPropertyValuesReportCode,
                        hideConfigSection: true,

                        autoRun: true,
                        collapseConfigSection: true
                      };

                      return options;
                    }
                  }
                }
              },
              fullWidth: true
            }
          });

          propReportControl.setAsCurrentControl();

          const getValue = (): Array<{ propertyDefinitionId: number, required: boolean, values: Array<any>, fromDayId?: number }> => {
              const EntityProperties = propReportControl.getReportPartControl("NewEntityProperties");
              const dataTable = EntityProperties.reportControlHost.currentControl.getReportPartControl("PropertyValueTable");
              const properties = dataTable.dataSets.values.properties.map(prop => 
                ({
                  required: prop.required,
                  propertyDefinitionId: prop.property.id,
                  values: prop.value[(Object.keys(prop.value) as any).find(val => val !== "from")],
                  fromDayId: prop.value.from,
                })).filter(prop => prop.required || prop.values.length);

              return properties;
          }

          return {
            ...propReportControl,
            getValue: getValue,
            isValid: () => {
              const properties = getValue();
              const invalid = properties.some(prop => prop.required && !prop.values.length);

              if (invalid) {
                createEditorOptions.validationModel.setErrorMessage("A required property is missing a value.");
              }
              return !invalid;
            }
          };
        }
      });

      formBuilder.setupDone();

      $(formBuilder).bind("valueChanged", function () {
        self._isDirty = true;
        self.clearNotification();
      });

      this._formBuilder = formBuilder;
    }

    public hideEditFields() {
      this._formBuilder.showEntries(false);
    }


    public focus() {
      let self = this;
      this.callAfterRender(function () {
        if (self._formBuilder) {
          self._formBuilder.getEntryByName("owner").focus();
        }
      });
    };

    public getEntityModel(): EntityValue {
      const name = this._formBuilder.getValueByName(this._formNames.name);
      const localCurrency = this._formBuilder.getValueByName(this._formNames.localCurrency);
      const propertyValues = this._formBuilder.getValueByName(this._formNames.properties);

      return {
        name: name,
        localCurrencyId: localCurrency.id,
        propertyValues: propertyValues,
        //things to make the parameter happy
        label: name,
        entityId: -1,
        resourceId: -1,
      }
    }

    public clearNotification() {
      this._formBuilder.formValidationModel.clearState();
    }

    public notify(options) {
      const self = this;

      if (options.success) {
        this.hideEditFields();

        const successHtml = $("<div>");

        // Link to entity
        $("<a>")
          .text(options.entity.label)
          .attr("href", () => {
            const reportLink = this._portalServices.reportLinker().getReportLink({
              reportAlias: "AssetInfo",
              parameters: { entityOrEntity: { entityId: options.entity.entityId } },
              autoRun: true,
              collapseConfigSection: true
            });
            return reportLink;
          })
          .appendTo(successHtml);

        successHtml
          .prepend("Entity ")
          .append(" saved.");

        const state = {
          success: {
            html: successHtml
          }
        };

        this._formBuilder.formValidationModel.state(state);
      }
      else {
        this._formBuilder.formValidationModel.setErrorMessage(options.message);
      }
    }

    public isDirty() {
      return this._isDirty;
    }

    public isValid() {
      return !this._formBuilder.hasErrors();
    }
  }

}